// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_hk-0";